import { z } from 'zod'

export const errorEnvelopeSchema = z.object({
  error: z.string(),
  code: z.string(),
  details: z.unknown().optional(),
  correlationId: z.string().optional(),
})

export type ErrorEnvelope = z.infer<typeof errorEnvelopeSchema>

export const messageEnvelopeSchema = z.object({
  message: z.string(),
})

export type MessageEnvelope = z.infer<typeof messageEnvelopeSchema>
